var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViews = function SvgViews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666",
    clipPath: "url(#views_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 2.966a4.66 4.66 0 0 1 4.391 2.869.4.4 0 0 1 0 .308 4.788 4.788 0 0 1-8.782 0 .4.4 0 0 1 0-.308A4.66 4.66 0 0 1 6 2.966m0-.75A5.43 5.43 0 0 0 .75 6a5.535 5.535 0 0 0 10.5 0A5.43 5.43 0 0 0 6 2.216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4.875a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25m0-.75a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "views_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgViews;